module.exports = __webpack_public_path__ + "static/candman-98c81b33cbef5141881b2df97784c6bc.jpg";